import React from "react";
import "./style.css";
import {formatCheeseName} from "../../../../../../utils/common";

import { Image } from "../../../../../../components/Image";
export const ContainerWrapper = ({data, sku, time, showDiscountInfo = true}) => {
  return (
    <div className="container-wrapper">
      <p className="p">
        <span className="text-wrapper-5">Get </span>

        <span className="text-wrapper-6">
          real results that last
          <br />
        </span>

        <span className="text-wrapper-5">and let Al do the work</span>
      </p>

      <div className="frame-11">
        {showDiscountInfo && sku.discount !== 0 &&
        <div className="discount-info">
          <p className="discount-text">{sku.discount}% DISCOUNT RESERVED FOR {time}</p>
        </div>}

        <div className="comparison-container">
          <div className="plan-container-2">
            <div className="plan-title-4">Restrictive diets</div>

            <Image src={`/static/image/questionnaire/weight-loss/payScreen/Pay${formatCheeseName(data.gender)}RestrictiveDiets.png`} alt="Image container" className="image-container" />

            <p className="plan-description">
              limited choice of
              <br />
              foods
              <br />
              gain weight back
            </p>
          </div>

          <div className="plan-container-3">
            <div className="plan-title-4">Our plan</div>

            <Image src={`/static/image/questionnaire/weight-loss/payScreen/Pay${formatCheeseName(data.gender)}OurPlan.png`} alt="Image container" className="image-container" />

            <p className="plan-description">
              learn to make
              <br />
              healthy choices
              <br />
              keep the weight off
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
